import { render } from "./RedeemGiftCardTutorial.vue?vue&type=template&id=5aa2c6da&scoped=true"
import script from "./RedeemGiftCardTutorial.vue?vue&type=script&lang=js"
export * from "./RedeemGiftCardTutorial.vue?vue&type=script&lang=js"

import "./RedeemGiftCardTutorial.vue?vue&type=style&index=0&id=5aa2c6da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa2c6da"]])

export default __exports__